'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_GroceryItem(name, plural, synonyms, aisle, isUsuallyStocked) {
  this.eI = null;
  this.nh = null;
  this.q1 = null;
  this.ng = null;
  this.oA = false;
  this.eI = name;
  this.nh = plural;
  this.q1 = synonyms;
  this.ng = aisle;
  this.oA = isUsuallyStocked;
}
export { $c_Lmealorama_GroceryItem as $c_Lmealorama_GroceryItem };
$p = $c_Lmealorama_GroceryItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItem;
/** @constructor */
function $h_Lmealorama_GroceryItem() {
}
export { $h_Lmealorama_GroceryItem as $h_Lmealorama_GroceryItem };
$h_Lmealorama_GroceryItem.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 839668128);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.eI));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nh));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.q1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ng));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.oA ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_GroceryItem)) {
    if (((this.oA === x$0.oA) && (this.eI === x$0.eI))) {
      var x = this.nh;
      var x$2 = x$0.nh;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.q1;
      var x$4 = x$0.q1;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.ng;
      var x$6 = x$0.ng;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "GroceryItem";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.eI;
      break;
    }
    case 1: {
      return this.nh;
      break;
    }
    case 2: {
      return this.q1;
      break;
    }
    case 3: {
      return this.ng;
      break;
    }
    case 4: {
      return this.oA;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_GroceryItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jw)));
}
export { $isArrayOf_Lmealorama_GroceryItem as $isArrayOf_Lmealorama_GroceryItem };
var $d_Lmealorama_GroceryItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GroceryItem, "mealorama.GroceryItem", ({
  jw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_GroceryItem as $d_Lmealorama_GroceryItem };
//# sourceMappingURL=mealorama.-Grocery-Item.js.map
